export default __webpack_public_path__ + "static/media/machineStory.6d5a6e63.mp3";